<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="800px">
      <c-card class="white" title="센터 운영 시간" style="position: static">
        <v-row>
          <v-col cols="12" md="2" sm="2" class="pb-0 mb-0">
            <span class="font-weight-bold black--text">[ 평일 ]</span>
          </v-col>
          <v-col cols="12" md="10" sm="10" class="pb-0 mb-0">
            <v-checkbox
                v-model="sameWeekday"
                label="평일 운영시간 전체 동일함"
                class="ma-0"
            ></v-checkbox>
          </v-col>
          <v-col cols="1" class="pt-0 mt-0"></v-col>
          <v-col cols="11" class="pt-0 mt-0">
            <day-operation-time
                v-if="sameWeekday === true"
                :day-info.sync="defaultWeekday"
            ></day-operation-time>

            <day-operation-time
                v-else
                v-for="day in weekdayList"
                :day-info.sync="day"
            ></day-operation-time>
          </v-col>
        </v-row>


        <v-row>
          <v-col cols="12" md="2" sm="2" class="pb-0 mb-0">
            <span class="font-weight-bold black--text">[ 주말 ]</span>
          </v-col>
          <v-col cols="12" md="10" sm="10" class="pb-0 mb-0">
            <v-checkbox
                v-model="sameWeekend"
                label="주말 운영시간 전체 동일함"
                class="ma-0"
            ></v-checkbox>
          </v-col>
          <v-col cols="1" class="pt-0 mt-0"></v-col>
          <v-col cols="11" class="pt-0 mt-0">

            <day-operation-time
                v-if="sameWeekend === true"
                :day-info.sync="defaultWeekend"
                equality-week="주말"
            ></day-operation-time>

            <day-operation-time
                v-else
                v-for="day in weekendList"
                :day-info.sync="day"
            ></day-operation-time>

          </v-col>
        </v-row>

        <v-row justify="center">
          <c-btn v-if="this.centerOperTimeData[0]" color="blue" class="mr-1 mt-2" @click="updateCenterOperTime" outlined>수정</c-btn>
          <c-btn v-else color="blue" class="mr-1 mt-2" @click="saveCenterOperTime" outlined>등록</c-btn>
          <c-btn class="mr-1 mt-2" outlined @click="cancel">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DayOperationTime from "@/views/Default/Common/DayOperationTime";

export default {
  components: {DayOperationTime},

  mounted() {
    this.copiedCenterOperTimeData = JSON.parse(JSON.stringify(this.centerOperTimeData));
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    centerOperTimeData: {
      type: Array,
      default: [],
    },
    centerId:{
      type:String,
      default:'',
    }
  },
  data: () => ({
    openFlag: false,

    sameWeekday: true,
    sameWeekend: true,

    defaultWeekday: {
      dayWeek: -1,
      operation: 'Enable',
      startResrv: '09:00',
      endResrv: '18:00',
      startDrive: '09:00',
      endDrive: '18:00',
    },
    defaultWeekend: {
      dayWeek: -2,
      operation: 'Enable',
      startResrv: '09:00',
      endResrv: '18:00',
      startDrive: '09:00',
      endDrive: '18:00',
    },

    weekdayList: [
      {
        dayWeek: 1,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      },
      {
        dayWeek: 2,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      },
      {
        dayWeek: 3,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      },
      {
        dayWeek: 4,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      },
      {
        dayWeek: 5,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      }
    ],
    weekendList: [
      {
        dayWeek: 6,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      },
      {
        dayWeek: 0,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      },
    ],


  }),
  watch: {
    open(newVal) {
      this.openFlag = newVal;

      if(newVal) {
        const weekendList = [];
        const weekdayList = [];

        // 데이터가 이미 존재할 경우 => 업데이트일 경우
        if (this.centerOperTimeData[0]) {
          this.centerOperTimeData.map(item => {
            if (item.dayWeek === 0 || item.dayWeek === 6) weekendList.push(item);
            else weekdayList.push(item);
            return item;
          });
          this.weekendList = weekendList;
          this.weekdayList = weekdayList;

          this.sameWeekday = weekdayList[0].sameWeekday === 'true';
          this.sameWeekend = weekendList[0].sameWeekend === 'true';

          if (this.sameWeekday) {
            let newDefaultWeekDay = {...weekdayList[0]};
            newDefaultWeekDay.dayWeek = -1;
            this.defaultWeekday = newDefaultWeekDay;
          }

          if (this.sameWeekend) {
            let newDefaultWeekend = {...weekendList[0]};
            newDefaultWeekend.dayWeek = -2;
            this.defaultWeekend = newDefaultWeekend;
          }

        }
      }

    },
    openFlag(newVal) {
      this.$emit('update:open', newVal);
    },
  },
  methods: {
    initData() {
      this.weekdayList = [
        {
          dayWeek: 1,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        },
        {
          dayWeek: 2,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        },
        {
          dayWeek: 3,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        },
        {
          dayWeek: 4,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        },
        {
          dayWeek: 5,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        }
      ];

      this.weekendList = [
        {
          dayWeek: 6,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        },
        {
          dayWeek: 0,
          operation: 'Enable',
          startResrv: '09:00',
          endResrv: '18:00',
          startDrive: '09:00',
          endDrive: '18:00',
        },
      ];

      this.defaultWeekday = {
        dayWeek: -1,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      };
      this.defaultWeekend = {
        dayWeek: -2,
        operation: 'Enable',
        startResrv: '09:00',
        endResrv: '18:00',
        startDrive: '09:00',
        endDrive: '18:00',
      };

      this.sameWeekday = true;
      this.sameWeekend = true;
    },
    saveCenterOperTime() {
      if (this.sameWeekday) {
        let defaultWeekday = this.defaultWeekday;
        this.weekdayList.map(item => {
          item.operation = defaultWeekday.operation;
          item.startResrv = defaultWeekday.startResrv;
          item.endResrv = defaultWeekday.endResrv;
          item.startDrive = defaultWeekday.startDrive;
          item.endDrive = defaultWeekday.endDrive;
        });
      }

      if (this.sameWeekend) {
        let defaultWeekend = this.defaultWeekend;
        this.weekendList.map(item => {
          item.operation = defaultWeekend.operation;
          item.startResrv = defaultWeekend.startResrv;
          item.endResrv = defaultWeekend.endResrv;
          item.startDrive = defaultWeekend.startDrive;
          item.endDrive = defaultWeekend.endDrive;
        })
      }
      let result = this.weekdayList.concat(this.weekendList).map(item => {
        let newItem = {...item};
        newItem.sameWeekday = this.sameWeekday;
        newItem.sameWeekend = this.sameWeekend;
        return newItem;
      }).map(item => {
        item.centerId = this.centerId;
        return item;
      });

      this.$emit('reqAddCenterOperTime', result);
    },
    updateCenterOperTime() {
      if (this.sameWeekday) {
        let defaultWeekday = this.defaultWeekday;


        this.weekdayList.map(item => {
          item.operation = defaultWeekday.operation;
          item.startResrv = defaultWeekday.startResrv;
          item.endResrv = defaultWeekday.endResrv;
          item.startDrive = defaultWeekday.startDrive;
          item.endDrive = defaultWeekday.endDrive;
        });
      }

      if (this.sameWeekend) {
        let defaultWeekend = this.defaultWeekend;
        this.weekendList.map(item => {
          item.operation = defaultWeekend.operation;
          item.startResrv = defaultWeekend.startResrv;
          item.endResrv = defaultWeekend.endResrv;
          item.startDrive = defaultWeekend.startDrive;
          item.endDrive = defaultWeekend.endDrive;
        })
      }

      let result = this.weekdayList.concat(this.weekendList).map(item => {
        let newItem = {...item};
        newItem.sameWeekday = this.sameWeekday;
        newItem.sameWeekend = this.sameWeekend;
        return newItem;
      });

      this.$emit('reqUpdateCenterOperTime', result);
    },
    cancel() {
      this.initData();
      this.openFlag = false;
    }
  }
}
</script>
<style scoped>

</style>